module.exports = __webpack_public_path__ + "images/img-3r7C4-Q.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/ru/3.png
// module id = 2352
// module chunks = 0